import { HANDLE_MEMBER_NEW_MESSAGE_NOTIFICATION, HANDLE_ADMIN_CONVERSATION_NEW_MESSAGE } from '../actions.type'
import { SET_MEMBER_NEW_MESSAGE_NOTIFICATION, SET_ADMIN_CONVERSATION_NEW_MESSAGE } from '../mutations.type'

const state = {
  isMemberHasNewMessage: {},
  adminConversationsNewMessage: {}
}

const getters = {
  isMemberHasNewMessage (state) {
    return state.isMemberHasNewMessage
  },
  adminConversationsNewMessage (state) {
    return state.adminConversationsNewMessage
  }
}

const actions = {
  [HANDLE_MEMBER_NEW_MESSAGE_NOTIFICATION] (context, isMemberHasNewMessage) {
    context.commit(SET_MEMBER_NEW_MESSAGE_NOTIFICATION, isMemberHasNewMessage)
  },
  [HANDLE_ADMIN_CONVERSATION_NEW_MESSAGE] (context, adminConversationsNewMessage) {
    context.commit(SET_ADMIN_CONVERSATION_NEW_MESSAGE, adminConversationsNewMessage)
  }
}

const mutations = {
  [SET_MEMBER_NEW_MESSAGE_NOTIFICATION] (state, isMemberHasNewMessage) {
    state.isMemberHasNewMessage = isMemberHasNewMessage
  },
  [SET_ADMIN_CONVERSATION_NEW_MESSAGE] (state, adminConversationsNewMessage) {
    state.adminConversationsNewMessage = adminConversationsNewMessage
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
